import React from 'react';
import PropTypes from 'prop-types';
// FETCH & CONFIG
import AppFetch from '../../fetch/AppFetch';
import AppAuth from '../../AppAuth';
// CONSTANTS
import { moduleConfig } from '../../lib/config/appConstants';

/**
 * Top level component for the Header bar at the top of the app
 */
export class ZuiHeader extends React.Component {
  constructor(props) {
    super(props);
    // Get the userinfo from AppFetch
    const userInfo = AppAuth.loggedIn() ? AppFetch.fetchUserInfo() : null;
    this.state = {
      userInfo: userInfo,
      entitledProducts: {},
      latestVersionInfo: {},
    };
  }

  render() {
    if (!this.props) {
      return null;
    }
    const { userInfo } = this.state;
    const { module } = this.props;

    return (
      <zui-shell-topbar unresolved>
        <zui-logo slot="logo" unresolved></zui-logo>
        {userInfo && userInfo.username && (
          <zui-shell-user
            unresolved
            slot="user"
            username={userInfo && userInfo.username ? userInfo.username : ''}
            logout-user-url="/edge/logout"
            manage-user-url={`/edge/myaccount/${
              module !== '' ? moduleConfig[module].shortName : ''
            }`}
            avatar={process.env.PUBLIC_URL + '/img/app-icons/UserAvatar.png'}
          >
            <div>Logout</div>
          </zui-shell-user>
        )}
      </zui-shell-topbar>
    );
  }
}

ZuiHeader.propTypes = {
  module: PropTypes.string.isRequired,
};

export default ZuiHeader;
